module.exports = __webpack_public_path__ + "static/media/yunjiadajianshanicon.2abf16d6.png";